import { useSelector } from 'react-redux'
import { Input } from 'antd'
import {
  faAt,
  faGlobe,
  faIdBadge,
  faIdCard,
  faLocationArrow,
  faMapLocationDot,
  faPhone
} from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import FormItem from '../../../../Components/shared/Forms/FormItem'
import { School, SchoolProperties } from '../../../../utils/entities/school'
import CountriesSelector from '../../../../Components/shared/Selectors/CountriesSelector'
import AreasSelector from '../../../../Components/shared/Selectors/AreasSelector'
import { getIdOrNull, isNonEmptyArray, validateString } from '../../../../utils'

const { ABBREVIATION, ADDRESS, AREA, COUNTRY, EMAIL, NAME, PHONE_NUMBER } = SchoolProperties

const SchoolForm = ({ errorFields = [], areas = [], countries, data, displayTitle, withEmail = false, onChange }) => {
  const t = useSelector(selectTranslate)

  const handleChange = key => value => onChange(new School({ ...data, [key]: value }))
  const handleEventChange = key => e => onChange(new School({ ...data, [key]: e.target.value }))

  const className = field => errorFields.includes(field) ? 'error-ant-border' : ''

  return (
    <>
      {displayTitle && <h3 className='pdl-12'> {t('common.school')}</h3>}

      <div className='pd-12'>
        <FormItem icon={faIdCard} label='common.name.dd' required>
          <Input
            className={className(NAME)}
            value={data[NAME] ?? null}
            onChange={handleEventChange(NAME)}
          />
        </FormItem>
        <FormItem icon={faIdBadge} label='common.abbreviation.dd' required>
          <Input
            className={className(ABBREVIATION)}
            value={data[ABBREVIATION] ?? null}
            onChange={handleEventChange(ABBREVIATION)}
          />
        </FormItem>
        <FormItem icon={faLocationArrow} label='common.address.dd' required>
          <Input
            className={className(ADDRESS)}
            value={data[ADDRESS] ?? null}
            onChange={handleEventChange(ADDRESS)}
          />
        </FormItem>
        <FormItem icon={faGlobe} label='common.country.dd' className={className(COUNTRY) + ' form-select'} required>
          <CountriesSelector
            countries={countries}
            multiple='default'
            values={getIdOrNull(data[COUNTRY]) ?? null}
            onChange={handleChange(COUNTRY)}
          />
        </FormItem>
        {isNonEmptyArray(areas) && (
          <FormItem icon={faMapLocationDot} label='school_portal.school.area.dd' className={className(AREA) + ' form-select'}>
            <AreasSelector
              areas={areas}
              values={getIdOrNull(data[AREA]) ?? null}
              onChange={handleChange(AREA)}
            />
          </FormItem>
        )}
        {withEmail && (
          <FormItem icon={faAt} label='common.contact_email.dd' required>
            <Input
              className={className(EMAIL)}
              value={data[EMAIL] ?? null}
              onChange={handleEventChange(EMAIL)}
            />
            {errorFields.includes(EMAIL) && (data[EMAIL] ?? '') !== '' && !validateString(data[EMAIL], { isEmail: true }).valid && (
              <div className='input-error'>{t('INVALID_EMAIL_FORMAT')}</div>
            )}
          </FormItem>
        )}
        <FormItem icon={faPhone} label='common.phone_number.dd'>
          <Input
            className={className(PHONE_NUMBER)}
            value={data[PHONE_NUMBER] ?? null}
            onChange={handleEventChange(PHONE_NUMBER)}
          />
        </FormItem>
      </div>
    </>
  )
}

export default SchoolForm
